import React, { useEffect, useState } from 'react';
import { Button, Col, Modal, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { BsImages } from 'react-icons/bs';
import { IReportItem } from '../../../../../../model/measure/IReportItem';
import { IPicture } from '../../../../../../model/shared/IPicture';
import { IPostImages } from '../../../../../../model/shared/IPostImages';
import { CustomImageHandler } from '../../../../../../shared/components/CustomImageHandler';
import { Fancybox } from '../../../../../../shared/components/Fancybox';
import { StatisticCard } from '../../../../../../shared/components/card/StatisticCard';
import { formatDate, getCorrectImageThumbnail, getExternalLink } from '../../../../../../shared/functions/Functions';
import { ErrorToast } from '../../../../../../utils/toasters';
import { reportingFields } from '../../../../../influencer/reporting/components/modals/components/ReportingBody';
import { MeasureService } from '../../service';
import PlayButtonOverlay from '../../../../../../shared/components/button/PlayButtonOverlay';
import { getFileType } from '../../../../../../shared/components/placeholder/FilePlaceholder';

interface IReportModalProps {
    show?: boolean;
    closeModal?: () => void;
    reportItemId: number;
    selectedImageArray?: IPicture[];
    selectedFeedItemImage?: IPicture | IPostImages;
}

export const DetailedPerInfluencerModal = ({
    show,
    selectedFeedItemImage,
    selectedImageArray,
    closeModal,
    reportItemId,
}: IReportModalProps) => {
    const { t } = useTranslation();
    const [reportPost, setReportPost] = useState<IReportItem>();
    const isVerified = reportPost?.isVerified || reportPost?.event?.isVerified;
    const isRejected = reportPost?.isRejected;
    const rejectedReason = reportPost?.rejectReason;
    const getCorrectImage = (reportPost: IReportItem | undefined) => {
        return reportPost?.relatedFeedItem?.postImages?.[0]
            ? reportPost?.relatedFeedItem?.postImages?.[0]
            : reportPost?.event?.attachments?.[0];
    };

    const getCorrectUser = (reportPost: IReportItem | undefined) => {
        return reportPost?.relatedFeedItem?.user ? reportPost?.relatedFeedItem?.user : reportPost?.event?.user;
    };

    useEffect(() => {
        show &&
            MeasureService.getReportPost(reportItemId)
                .then(response => setReportPost(response))
                .catch(error => ErrorToast(error));
    }, [reportItemId]);

    return (
        <Modal size="lg" centered show={show} onHide={closeModal}>
            <Modal.Body className="p-0">
                <Row className="m-0">
                    <Col md={4} className="p-0 border-right-lg">
                        <Fancybox>
                            {!!selectedImageArray?.length ? (
                                selectedImageArray?.map(selectedImage => {
                                    return (
                                        <div
                                            data-fancybox={`gallery-feedImage`}
                                            className={`cursor-pointer ${
                                                selectedFeedItemImage?.id !== selectedImage?.id ? 'd-none' : ''
                                            }`}
                                            key={selectedImage?.id}
                                            data-src={
                                                !!selectedImage.externalLink
                                                    ? `#html-content-${selectedImage?.id}`
                                                    : selectedImage?.path ?? '/icons/filePlaceholder.png'
                                            }
                                            data-thumb={
                                                getFileType(
                                                    selectedImage.name,
                                                    getCorrectImageThumbnail(
                                                        !!selectedImage?.externalLink,
                                                        selectedImage?.originalName ?? '',
                                                        selectedImage?.thumbPath ?? '',
                                                        selectedImage?.path ?? ''
                                                    ),
                                                    selectedImage.externalLink
                                                ).imgSrc
                                            }
                                        >
                                            {selectedImage.externalLink ? (
                                                <>
                                                    <div
                                                        id={`html-content-${selectedImage?.id}`}
                                                        style={{ display: 'none', maxWidth: '500px' }}
                                                    >
                                                        <a
                                                            href={getExternalLink(selectedImage?.externalLink)}
                                                            target="_blank"
                                                            className="cursor-pointer"
                                                        >
                                                            <CustomImageHandler
                                                                photoPath={getCorrectImageThumbnail(
                                                                    !!selectedImage?.externalLink,
                                                                    selectedImage?.originalName ?? '',
                                                                    selectedImage?.thumbPath ?? '',
                                                                    selectedImage?.path
                                                                )}
                                                                altTag="Event"
                                                                style={{ height: 200 }}
                                                                thumbnailPath={selectedImage?.thumbnail}
                                                                placeholder={getCorrectImageThumbnail(
                                                                    !!selectedImage?.externalLink,
                                                                    selectedImage?.originalName ?? '',
                                                                    selectedImage?.thumbPath ?? '',
                                                                    selectedImage?.path
                                                                )}
                                                                classes="w-100 h-100 img-cover reporting-modal-height"
                                                            />
                                                        </a>
                                                        <a
                                                            href={getExternalLink(selectedImage?.externalLink)}
                                                            target="_blank"
                                                            className="cursor-pointer text-center"
                                                        >
                                                            {getExternalLink(selectedImage?.externalLink)}
                                                        </a>
                                                    </div>
                                                    <CustomImageHandler
                                                        photoPath={getCorrectImageThumbnail(
                                                            !!selectedImage?.externalLink,
                                                            selectedImage?.originalName ?? '',
                                                            selectedImage?.thumbPath ?? '',
                                                            selectedImage?.path
                                                        )}
                                                        altTag="Event"
                                                        style={{ height: 200 }}
                                                        thumbnailPath={selectedImage?.thumbnail}
                                                        placeholder={getCorrectImageThumbnail(
                                                            !!selectedImage?.externalLink,
                                                            selectedImage?.originalName ?? '',
                                                            selectedImage?.thumbPath ?? '',
                                                            selectedImage?.path
                                                        )}
                                                        classes="w-100 h-100 img-cover reporting-modal-height"
                                                    />
                                                </>
                                            ) : selectedImage?.type?.includes('video') ? (
                                                <PlayButtonOverlay>
                                                    <CustomImageHandler
                                                        placeholder={getCorrectImageThumbnail(
                                                            !!selectedImage?.externalLink,
                                                            selectedImage?.originalName ?? '',
                                                            selectedImage?.thumbPath ?? '',
                                                            selectedImage?.path ?? ''
                                                        )}
                                                        photoPath={
                                                            getFileType(
                                                                selectedImage.name,
                                                                getCorrectImageThumbnail(
                                                                    !!selectedImage?.externalLink,
                                                                    selectedImage?.originalName ?? '',
                                                                    selectedImage?.thumbPath ?? '',
                                                                    selectedImage?.path ?? ''
                                                                )
                                                            ).imgSrc
                                                        }
                                                        classes="w-100 h-100 img-cover reporting-modal-height"
                                                        thumbnailPath={selectedImage?.thumbnail}
                                                        altTag={getCorrectImage(reportPost)?.name ?? ''}
                                                    />
                                                </PlayButtonOverlay>
                                            ) : (
                                                <CustomImageHandler
                                                    placeholder={getCorrectImageThumbnail(
                                                        !!selectedImage?.externalLink,
                                                        selectedImage?.originalName ?? '',
                                                        selectedImage?.thumbPath ?? '',
                                                        selectedImage?.path ?? ''
                                                    )}
                                                    photoPath={
                                                        getFileType(
                                                            selectedImage.name,
                                                            getCorrectImageThumbnail(
                                                                !!selectedImage?.externalLink,
                                                                selectedImage?.originalName ?? '',
                                                                selectedImage?.thumbPath ?? '',
                                                                selectedImage?.path ?? ''
                                                            )
                                                        ).imgSrc
                                                    }
                                                    classes="w-100 h-100 img-cover reporting-modal-height"
                                                    thumbnailPath={selectedImage?.thumbnail}
                                                    altTag={getCorrectImage(reportPost)?.name ?? ''}
                                                />
                                            )}
                                        </div>
                                    );
                                })
                            ) : (
                                <CustomImageHandler
                                    classes="w-100 h-100 img-cover reporting-modal-height"
                                    photoPath=""
                                    altTag=""
                                />
                            )}
                        </Fancybox>
                    </Col>
                    <Col md={8}>
                        <div className="px-1 pt-3 d-flex flex-column justify-content-between h-100">
                            <div>
                                <div className="d-flex justify-content-between">
                                    <div className="d-flex align-items-center">
                                        <CustomImageHandler
                                            altTag="User Profile"
                                            classes="middle-rounded-logo"
                                            thumbnailPath={getCorrectUser(reportPost)?.profilePhoto?.thumbnail}
                                            photoPath={getCorrectUser(reportPost)?.profilePhoto?.path}
                                            name={
                                                getCorrectUser(reportPost)?.displayName
                                                    ? getCorrectUser(reportPost)?.displayName
                                                    : `${getCorrectUser(reportPost)?.firstName ?? ''}${
                                                          getCorrectUser(reportPost)?.lastName
                                                              ? ' ' + getCorrectUser(reportPost)?.lastName
                                                              : ''
                                                      }`.trim()
                                            }
                                        />

                                        <div className="ml-2">
                                            <h5 className="font-weight-semi-bold mb-1">
                                                {getCorrectUser(reportPost)?.displayName
                                                    ? getCorrectUser(reportPost)?.displayName
                                                    : `${getCorrectUser(reportPost)?.firstName ?? ''}${
                                                          getCorrectUser(reportPost)?.lastName
                                                              ? ' ' + getCorrectUser(reportPost)?.lastName
                                                              : ''
                                                      }`.trim()}
                                            </h5>

                                            <span className="text-muted d-block mt-n1">
                                                {getCorrectUser(reportPost)?.displayName
                                                    ? `${getCorrectUser(reportPost)?.firstName ?? ''}${
                                                          getCorrectUser(reportPost)?.lastName
                                                              ? ' ' + getCorrectUser(reportPost)?.lastName
                                                              : ''
                                                      }`.trim() || '-'
                                                    : '-'}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="d-flex align-items-center my-2">
                                        <img
                                            src={reportPost?.socialPlatform?.path}
                                            alt={reportPost?.socialPlatform?.name}
                                        />

                                        <div className="d-flex flex-column">
                                            <span className="font-weight-semi-bold ml-1 mr-3">
                                                {reportPost?.additionalPost && t('brand.campaign.measure.additional')}{' '}
                                                {t(`general.platforms.${reportPost?.socialPlatform?.name}`)}{' '}
                                                {!reportPost?.additionalPost
                                                    ? `${reportPost?.event?.platformPosition ?? '-'}/${
                                                          reportPost?.event.offerItem?.nbPosts
                                                      }`
                                                    : ''}
                                            </span>

                                            {reportPost?.event?.postingDate && (
                                                <span className="text-muted ml-1">
                                                    {formatDate(reportPost?.event?.postingDate)}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <p className="mt-4">{reportPost?.description}</p>
                                <div className="d-flex flex-wrap mt-3">
                                    {isVerified &&
                                        reportingFields
                                            ?.filter(field => reportPost?.[field as keyof IReportItem])
                                            ?.map(field => (
                                                <StatisticCard
                                                    classes="m-1 m-md-2 w-30"
                                                    key={field}
                                                    number={Number(reportPost?.[field as keyof IReportItem])}
                                                    text={t(`influencer.reporting.${field}`)}
                                                />
                                            ))}
                                </div>
                                {!isVerified && !isRejected && (
                                    <div className="flex flex-col items-center mt-5 text-center">
                                        <img
                                            src="/icons/being-verified-icon.svg"
                                            alt="Being verified icon"
                                            height={90}
                                        />
                                        <p className="mt-4">{t('brand.campaign.measure.KPI_being_verified')}</p>
                                    </div>
                                )}
                                {isRejected && (
                                    <div className="text-center mt-md-4">
                                        <img
                                            className="mb-3"
                                            src="/icons/not-approved-icon.svg"
                                            alt="Not approved icon"
                                            height={90}
                                        />
                                        <div className="border-danger default-radius p-4">
                                            <h6 className="text-center">
                                                {t('influencer.reporting.rejection_reason')}:
                                            </h6>
                                            <p className="text-muted">{rejectedReason}</p>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <Modal.Footer className="d-flex justify-content-between align-items-center px-0 mb-1">
                                <div className="d-flex flex-column">
                                    <span className="text-muted m-0">
                                        {t('general.reported')}: {formatDate(reportPost?.createdAt)}
                                    </span>
                                    <span className="m-0 text-muted">
                                        {t('general.placementId')}: #{reportPost?.event?.id}
                                    </span>
                                </div>
                                <div className="d-flex justify-content-end align-items-end m-0">
                                    <Button onClick={closeModal} variant="outline-primary">
                                        {t('general.button.cancel')}
                                    </Button>
                                    {isVerified && !!reportPost?.reportImages?.length && (
                                        <Fancybox>
                                            {reportPost?.reportImages?.map((reportImage, index) => {
                                                return (
                                                    <div
                                                        key={reportImage?.id}
                                                        data-fancybox={`gallery-reportImage`}
                                                        className="cursor-pointer ml-2"
                                                        data-src={
                                                            reportImage?.reportPath
                                                                ? reportImage?.reportPath
                                                                : '/icons/filePlaceholder.png'
                                                        }
                                                    >
                                                        {index === 0 && (
                                                            <Button variant="primary">
                                                                <BsImages color="#fff3" className="text-white mr-1" />
                                                                {t('brand.campaign.measure.insights')}
                                                            </Button>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </Fancybox>
                                    )}
                                </div>
                            </Modal.Footer>
                        </div>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    );
};
